module.exports = __webpack_public_path__ + "img/CoolmathGames-800x600.55f69ac5.png";